module.exports = __webpack_public_path__ + "assets/08829c795d7a99bc93d55fafb33f90b4.png";